const conga = require("./500-miles-conga.mp4");
const selfie = require("./selfie.mp4");
const mio = require("./mio-i-love-rock.mp4");
const were_not_gonna_take = require("./were-not-gonna-take.mp4");

export const videos = [conga, selfie, mio, were_not_gonna_take] as string[];
